module.exports = __webpack_public_path__ + "static/media/icn-aethereum.48a2bb02.svg";